<!--
 * @Description: 认证回调
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div>跳转中...</div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import native from '@/utils/native';
import { useRoute } from 'vue-router';

const route = useRoute();

onMounted(() => {
  setTimeout(() => {
    native.method.authenticationDone(
      Reflect.get(route.query as any, 'type') || 'individual'
    );
  }, 500);
});
</script>
<style>
.van-button {
  color: #fff !important;
  font-size: 20px !important;
  width: 200px !important;
  margin: 20px !important;
}
</style>
